import axios from 'axios';
import { getAcceptLanguage } from '../i18n/apiLanguage';
import { installRequestId } from '../utils/requestId';

/** Global Accept-Language for all axios requests (web). Import once at app bootstrap. */
axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (!config.headers['Accept-Language']) {
    config.headers['Accept-Language'] = getAcceptLanguage();
  }
  return config;
});
installRequestId(axios);
